/**
 * @file 申请试用页面
 * @author wangzhuang
 * */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {List, InputItem} from 'antd-mobile';
import {fetchCmsapiIndexData, fetchUserApply} from '../../actions/applyAction';
import {confirm} from '../activity/index';

import './index.less';

class Apply extends Component {
    static propTypes = {
        fetchCmsapiIndexData: PropTypes.func,
        fetchUserApply: PropTypes.func,
        userApplyData: PropTypes.object,
        cmsapiUserapply: PropTypes.object,
        userLoginstate: PropTypes.object,
        match: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            overallTypeIndex: 2,    // 身份类型
            enterpriseName: '',  // 企业名称
            codeVal: '',
            enterpriseNameError: false,
            userNameError: false,
            codeError: false,
            userName: '',   // 真实姓名
            hasError: false,
            userPhoneVal: '', // 电话号码
            userEmailVal: '', // 邮箱
            workId: [this.props.match.params.Iid], // 感兴趣的业务
            overallTextarea: '', // 咨询内容
            userPhoneError: false,
            desInfoError: false,
            userPhoneErrorHint: '手机号码不能为空',
            userEmailError: false,
            userEmailErrorHint: '联系邮箱不能为空',
            codeImg: '/catpcha',
            codeHint: '验证码不能为空',
            from: this.getRequest().from
        };
        this.overallType = [
            {val: '企业', id: 2},
            {val: '个人', id: 1}
        ];
    }

    componentDidMount() {
        this.confirm = confirm({
            disableCloseByMask: true,
            title: <div style={{width: '6.5rem', margin: '0 auto'}}>
                百度安全个人信息保护扶持计划企业入驻协议
            </div>,
            type: 'large',
            content: (
                <div className="details-wrapper">
                    <div className="details">
                        <p className="indent">欢迎加入百度安全APP消息推送扶持计划！</p>
                        <p className="indent">
                            本协议由申请加入百度安全APP消息推送扶持计划的企业（以下简称“企业”）与北京百度网讯科技有限公司（以下简称“百度安全”）签署。
                            在接受本协议之前，请仔细阅读并遵守本协议的全部内容。请务必审慎阅读、充分理解各条款的内容，特别是以粗体下划线标注的条款。
                            企业通过网络页面点击确认申请加入百度安全APP消息推送扶持计划（以下简称“本计划”）将视为对本协议的接受，已达成协议并同意接受本协议的全部约定内容。
                        </p>
                        <p className="indent">
                            本协议由申请加入百度安全APP消息推送扶持计划的企业（以下简称“企业”）与北京百度网讯科技有限公司（以下简称“百度安全”）签署。
                            在接受本协议之前，请仔细阅读并遵守本协议的全部内容。请务必审慎阅读、充分理解各条款的内容，特别是以粗体下划线标注的条款。
                            企业通过网络页面点击确认申请加入百度安全APP消息推送扶持计划（以下简称“本计划”）将视为对本协议的接受，已达成协议并同意接受本协议的全部约定内容。
                        </p>
                        <p className="indent">
                            本协议内容包括协议正文及所有百度安全已经发布的或将来可能发布的服务使用规则。所有规则为本协议不可分割的一部分，与协议正文具有相同法律效力。
                            百度安全有权不时修改本协议和相关规则的内容，修改后的内容将公布于本计划相关页面，如企业继续参与并使用本计划项下服务的，则视为企业接受并同意遵守修改后的内容。
                            如企业对修改存有任何异议， 或者企业不同意百度安全公布的规则的，企业应立即停止使用本计划项下服务，同时向百度安全提交书面终止通知。
                        </p>
                        <p className="indent">
                            本协议内容包括协议正文及所有百度安全已经发布的或将来可能发布的服务使用规则。所有规则为本协议不可分割的一部分，与协议正文具有相同法律效力。
                            百度安全有权不时修改本协议和相关规则的内容，修改后的内容将公布于本计划相关页面，如企业继续参与并使用本计划项下服务的，则视为企业接受并同意遵守修改后的内容。
                            如企业对修改存有任何异议， 或者企业不同意百度安全公布的规则的，企业应立即停止使用本计划项下服务，同时向百度安全提交书面终止通知。
                        </p>
                        <p>一、 定义</p>
                        <p>
                            1.APP消息推送扶持计划：指由百度安全发起的，
                            依托百度安全的App消息推送技术能力，通过所运营的百度慧推服务平台（地址：https://cloud.baidu.com/product/spp.html）
                            帮助中小企业App提供各类型消息推送功能。
                            本协议中可称为“本计划”（本计划官网页面地址：https://anquan.baidu.com/page/60）。
                        </p>
                        <p>
                            2.APP消息推送扶持计划入驻企业：指符合本协议项下申请条件，完全同意本协议条款，完成注册申请流程，并经百度安全批准加入本计划并使用本计划各项服务的企业。
                            本协议中可称为“入驻企业”。
                        </p>
                        <p>
                            3.APP消息推送扶持计划服务：指百度安全为入驻企业提供的App消息推送技术服务。本协议中可称为“服务”，具体内容详见本协议第三条约定。
                            为免歧义，本协议中的服务范围仅限中华人民共和国大陆地区。
                        </p>
                        <p>
                            4.APP消息推送扶持计划账号：指企业为申请加入本计划以及使用本计划项下服务而登录的百度账号。本协议中可称为“账号”。
                        </p>
                        <p>
                            5.百度账号：定义详见《<a
                                target="_blank"
                                className="spu-link"
                                rel="noopener noreferrer"
                                href="https://passport.baidu.com/static/passpc-account/html/protocal.html">百度用户协议</a>》。
                        </p>
                        <p>二、 申请条件及流程</p>
                        <p>1.申请加入本计划的企业需符合以下条件：</p>
                        <p className="indent">1）营业执照所登记的注册资本小于1000万元人民币的中华人民共和国大陆地区企业。</p>
                        <p className="indent">2）企业从事业务范围为App开发/运营。</p>
                        <p className="indent">3）企业所开发/运营的单个App用户量小于百万且用户月活量小于百万。/运营。</p>
                        <p className="indent">4）企业同意授权百度安全在百度安全官网、线下展会、线上传播等位置进行企业品牌露出（以企业申请时提供的企业名称、简称以及LOGO为准）。</p>
                        <p className="indent">5）企业需在使用本计划项下服务的App内显著位置露出本计划标识（以百度安全另行通知确认为准）。</p>
                        <p className="indent">6）企业需参与百度安全的调查问卷，反馈使用本计划项下服务的体验、遇到的问题等。</p>
                        <p>2.申请流程</p>
                        <p className="indent">
                            1）企业在申请加入本计划时，需要提供与申请条件账号注册信息相符的相关的资质证明材料以及其他申请条件必要证明材料，
                            百度安全将在审查企业提交的相关证明材料后决定企业是否可加入本计划以及是否向企业提供相应服务。
                        </p>

                        <p className="indent">
                            2）申请加入本计划并使用服务，企业需要登录百度账号。如果企业没有百度账号，需要首先注册百度账号。
                            在注册百度账号时，企业应阅读并接受《百度用户协议》
                            （https://passport.baidu.com/static/passpc-account/html/protocal.html）。
                            在完成百度账号注册流程后后，企业将得到一个账号和密码。如果企业已拥有百度账号，可以通过企业的百度账号和密码直接登录。
                            百度安全将根据账号和密码来确认企业的身份，企业需要妥善保管其账号和密码，
                            对企业在账号中的所有活动和事件（包括但不限于网上点击同意各类规则协议、发布信息、披露信息、订购服务、支付费用等）承担全部责任。
                        </p>
                        <p className="indent">
                            3）企业在注册账号、申请加入本计划以及使用相关服务时，提供的用户资料应真实、准确、完整、合法有效。用户资料如有变动的，应及时更新；
                            如果企业提供的用户资料不合法、不真实、不准确、不详尽的，企业需承担因此引起的相应责任及后果，并且百度安全保留终止企业使用本计划各项服务的权利。
                        </p>
                        <p className="indent">
                            4）如果企业将其帐号、密码转让、出借、销售或以任何脱离控制的形式交由任何第三方使用，
                            由此导致的针对企业、百度安全及其关联方、或任何第三方造成的损害，企业将承担全部责任。
                        </p>
                        <p className="indent">
                            5）如企业发现帐号遭他人非法使用，应立即通知百度安全。
                            因黑客行为或企业的保管疏忽导致帐号、密码遭他人非法使用，百度安全不承担任何责任。
                        </p>
                        <p>三、	服务内容</p>
                        <p>在本计划存续期间，本计划项下百度安全向入驻企业提供的服务内容如下：</p>
                        <p className="indent">
                            1.APP消息推送技术服务：入驻企业集成“百度慧推”APP消息推送SDK，并登陆百度慧推服务平台开通服务后，
                            可获得免费APP消息推送技术服务，服务期限为一年（服务期限自服务开通之日起计算，如服务期满之前本计划停运，则服务自停运之日起终止）。
                            服务内容包括APP消息推送基础功能、SDK接入技术咨询服务等，具体服务内容及服务规则以服务期限内百度慧推服务平台公示为准
                        </p>
                        <p className="indent">
                            2.APP消息推送技术培训：入驻企业可参加百度安全不定期举办APP消息推送技术沙龙 ，了解最新政策和APP消息推送技术。
                            培训的具体时间、地点以及内容以百度安全服务平台公示、百度慧推服务平台公示或百度安全另行通知为准。
                        </p>
                        <p>四、入驻须知</p>
                        <p>
                            1.企业知晓并同意，使用本计划项下服务即视为企业同意并接受包括《<a
                                href="https://anquan.baidu.com/help?id=16&typeId=&file_type=2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >百度安全服务平台用户协议</a>》、
                            《<a href="https://console.bce.baidu.com/spp/#/protocol"
                                target="_blank"
                                rel="noopener noreferrer">百度慧推平台服务协议</a>》
                            及《<a
                                target="_blank"
                                rel="noopener noreferrer"
                                href="http://sofire.bdstatic.com/push/privacy.html">
                                百度慧推隐私政策
                            </a>》在内的相关服务协议以及其他百度安全所公示的服务规则。
                        </p>
                        <p>
                            2.企业承诺，加入本计划以及使用本计划项下服务时严格遵守任何可能适用的的法律法规，
                            并应获得在APP上集成百度慧推SDK和使用百度慧推平台服务应获得的APP相关授权，包括但不限于APP最终用户的授权。
                        </p>

                        <p>
                            3.企业应遵守所适用的关于保护个人数据和隐私、通信自由及保障网络安全运行等方面的法律法规。
                        </p>
                        <p>
                            4.为了便于企业申请、加入本计划以及使用本计划项下服务，企业理解并接受，百度安全可以通过邮件、短信、电话、站内信、弹出消息等形式，向企业发送公示规则等各类通知。
                        </p>
                        <p>
                            5.企业不得使用本计划及项下服务上载、传送、发布或传播敏感信息和违反国家法律法规政策的信息（形式包括但不限于文字、图片、语音、音视频等），
                            此类信息包括但不限于：
                        </p>
                        <p className="indent">
                            1）反对宪法所确定的基本原则的；
                        </p>
                        <p className="indent">
                            2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
                        </p>
                        <p className="indent">
                            3）损害国家荣誉和利益的；
                        </p>
                        <p className="indent">
                            4）煽动民族仇恨、民族歧视、破坏民族团结的；
                        </p>
                        <p className="indent">
                            5）破坏国家宗教政策，宣扬邪教和封建迷信的；
                        </p>
                        <p className="indent">
                            6）散布谣言，扰乱社会秩序，破坏社会稳定的；
                        </p>
                        <p className="indent">
                            7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
                        </p>
                        <p className="indent">
                            8）侮辱或者诽谤他人，侵害他人合法权益的；
                        </p>
                        <p className="indent">
                            9）含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其他道德上令人反感的内容；
                        </p>
                        <p className="indent">
                            10）含有侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；
                        </p>
                        <p className="indent">
                            11）含有骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的内容；
                        </p>
                        <p className="indent">
                            12）含有其他违反法律法规、政策、公序良俗、社会公德或干扰商城运营和侵犯其他企业或第三方合法权益内容的信息。
                        </p>
                        <p>6.企业承诺不对本计划项下服务采取以下行为：</p>
                        <p className="indent">
                            1)	对本计划项下服务进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现软件的源代码；
                        </p>
                        <p className="indent">
                            2)	对百度安全拥有知识产权的内容进行出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
                        </p>
                        <p className="indent">
                            3)	对本计划项下服务运行过程中释放到任何终端内存中的数据、服务运行过程中终端与服务器端的交互数据，
                            以及服务运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经百度安全授权的第三方工具/服务接入本计划项下服务相关系统；
                        </p>
                        <p className="indent">
                            4)	通过修改或伪造服务运行中的指令、数据，增加、删减、变动服务的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
                        </p>
                        <p className="indent">
                            5)	通过非百度安全开发、授权的第三方软件、插件、外挂、系统，登录或使用本计划项下服务，或制作、发布、传播上述工具；
                        </p>
                        <p className="indent">
                            6)	自行或者授权他人、第三方软件对本计划项下服务相关软件及其组件、模块、数据进行干扰；
                        </p>
                        <p className="indent">
                            7)	采取其他未经百度安全明示授权的行为。
                        </p>
                        <p>
                            7.企业承诺不以任何形式使用本计划项下服务来侵犯百度安全及其关联方的利益，或从事任何可能对百度安全及其关联方造成损害或不利于百度安全及其关联方的行为。
                            如因企业使用本计划项下服务的行为，导致百度安全及其关联方或任何第三方为此承担了相关的责任，则企业需全额赔偿百度安全及其关联方或任何第三方的相关支出及损失，
                            包括合理的律师费用。
                        </p>
                        <p>
                            8.企业不得从事与百度慧推平台产品/服务相同或类似的APP消息推送业务，
                            不得研发、生产、经营与百度慧推平台产品/服务相同或类似的产品/服务。
                        </p>
                        <p>
                            9.百度安全可根据本计划实际情况或自身运营安排在法律允许的范围内对本协议及本计划相关规则进行调整，
                            并通过本计划相关页面将调整内容进行公布，或以本协议约定的方式将调整内容通知入驻企业。相关调整内容一经公布/通知即产生效力，
                            入驻企业应当予以遵守。
                        </p>
                        <p>五、	费用与结算</p>
                        <p>1.本协议第三条约定的“服务内容”为免费服务，入驻企业无须就使用前述服务向百度安全支付任何费用。</p>
                        <p>3.除本协议第三条约定的“服务内容”外， 入驻企业使用百度安全及百度公司任何服务，均须根据相关服务协议及规则支付相应服务费用。</p>
                        <p>六、	知识产权</p>
                        <p>4.百度安全对其独立创作、设计、制作的以及委托他人创作的内容，
                            包括但不限于文字、商标、标识、外观设计、版面设计、软件、图片、音视频、算法、模型等，享有所有权和知识产权，
                            对其从第三方获得合法许可的信息内容享有合法使用权。
                            未经百度安全事先书面授权，企业不得为任何目的保存、备份、使用或授权他人使用前述内容。</p>
                        <p>
                            5.企业同意本计划的全部运营数据的全部权利均归属于百度安全，且是百度安全的商业秘密，
                            依法属于入驻企业享有的相关权利除外。未经百度安全事先书面同意，任何人不得为任何目的擅自保存、备份、使用前述数据，
                            亦不得以任何形式将前述数据提供给他人或授权他人使用。未经百度安全事先书面同意，企业不得为任何目的擅自保存、备份、使用、提供给他人或授权他人使用前述运营数据。
                        </p>
                        <p>
                            6.未经百度安全事先书面同意，任何人不得以任何方式
                            （包括但不限于使用机器人、蜘蛛、其他自动设备、手动程序或在非百度安全服务器上设置镜像等）来抓取、复制或监视本计划项下服务或其所包含的任何内容；
                            否则，百度安全有权依法追究法律责任。
                        </p>
                        <p>七、	违约责任</p>
                        <p>1.根据入驻企业违规情形的严重程度，百度安全有权对入驻企业采取如下一种或多种处理措施；
                            情节严重的，百度安全还将一并追究入驻企业的法律责任：</p>
                        <p className="indent">
                            1)	删除违规信息；
                        </p>
                        <p className="indent">
                            2)	限制、中止入驻企业使用本计划项下服务
                        </p>
                        <p className="indent">
                            3)	终止入驻企业使用本计划项下服务，终止本协议，并追究入驻企业的法律责任；
                        </p>
                        <p className="indent">
                            4)	其他百度安全认为适合的处理措施。
                        </p>
                        <p>
                            2.企业理解并同意百度安全有权以普通或非专业人员的知识水平标准对企业的行为进行单方认定，
                            并根据单方认定结果适用协议、规则予以处理或中止、终止向企业提供服务（包括中止或终止本计划项下服务），且无须征得企业的同意或提前通知予企业。
                            百度安全根据相关规则对企业进行处理后，不免除企业应当承担的法律责任。企业不可撤销地认可百度安全的单方认定结果及证据（包括但不限于百度安全通过技术方式收集的证据等）。
                        </p>
                        <p>
                            3.如因企业违反有关法律法规或者本协议、相关规则之规定，使百度安全遭受任何损失、受到其他企业、任何第三方的索赔或任何行政管理部门的处罚，
                            企业应对百度安全、其他企业或相关第三方的实际损失进行全额赔偿，包括合理的律师费用。
                        </p>
                        <p>
                            4.在百度安全违背本协议约定的情况下，
                            百度安全向企业承担的总体责任和赔偿不超过百度安全在截止违约之时基于服务从企业处获得的技术服务费用收入的总额，
                            该等技术服务费用收入也仅限于以货币方式收取的实际收入而不包括其他利益。
                        </p>
                        <p>八、	免责声明</p>
                        <p>
                            1.入驻企业对本计划项下服务的使用承担风险。
                            百度安全对此不作任何类型的担保，不论是明确的或隐含的，但是不对商业性的隐含担保、特定目的和不违反规定的适当担保作限制。
                            百度安全不担保服务一定能满足入驻企业的要求，也不担保服务不会受中断，对服务的及时性，安全性，出错发生，数据丢失等都不作担保。
                        </p>
                        <p>
                            2.百度安全对本计划项下服务以及相关服务将尽力维护其安全性及方便性，因下列原因导致的服务或系统不适用、不便利、故障而造成损失的，
                            百度安全不承担违约责任和需要支付任何性质的赔偿：
                        </p>
                        <p className="indent">
                            1)	系统停机维护；
                        </p>
                        <p className="indent">
                        2)	通讯终端或电信设备出现故障不能进行数据传输的；
                        </p>
                        <p className="indent">
                        3)	因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成系统障碍不能执行业务的；
                        </p>
                        <p className="indent">
                        4)	由于黑客攻击、电信部门技术调整或故障、网站升级、第三方问题等原因而造成的服务中断或者延迟。
                        </p>
                        <p className="indent">
                        3.	百度安全对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：不正当使用网络服务，非法使用网络服务或入驻企业传送的信息有所变动。
                        这些行为都有可能会导致百度安全的形象受损，所以百度安全事先提出这种损害的可能性。
                        </p>
                        <p>九、	协议终止及转让</p>
                        <p>1.本协议在符合以下任意一项情形时终止：</p>
                        <p className="indent">1)	通知解除：百度安全可提前15天以书面通知的方式终止本协议而无须承担违约责任；</p>
                        <p className="indent">2)	因法规政策或主管机关要求，本计划项下服务将可能中止或终止，
                            且百度安全没有义务或无法事先通知企业，企业同意不因此要求百度安全承担违约责任；</p>
                        <p className="indent">3)	单方解除权：出现下列情况之一的，百度安全有权立刻终止本协议，且按有关规则对企业进行处罚：</p>
                        <p className="indent">a)	企业违反本协议中的任何承诺或保证，包括但不限于本协议项下的任何约定；</p>
                        <p className="indent">b)	协议规定的其他协议终止条件发生或实现，导致本协议终止。</p>
                        <p>2.无论本协议因何原因终止，企业在协议终止前的行为所导致的任何责任，企业必须完全且独立地承担；
                            协议终止后，百度安全无需继续向企业提供服务。</p>
                        <p>3.百度安全有权将本协议项下的全部权利和义务转让给关联方，而无须征得企业的事先同意，
                            届时百度安全将通过邮件、站内信、页面公告等方式向企业发出转让通知。</p>
                        <p>十、	通知及送达</p>
                        <p>1.百度安全对于企业所有的通知均可通过站内信、页面公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p>
                        <p>2.企业对于百度安全的通知应当通过百度安全在本页面公布的联系方式进行送达。</p>
                        <p>十一、	法律适用及争议解决</p>
                        <p>1.本协议适用中华人民共和国大陆地区法律。</p>
                        <p>2.因企业与百度安全就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成，任何一方均有权向北京市海淀区人民法院起诉。</p>
                        <p>十二、	联系我们</p>
                        <p>1.企业对本协议有任何意见或建议可发送邮件至spp_support@baidu.com。</p>
                        <p>2.为保障我们高效处理企业的问题，需要企业提交身份证明、有效联系方式和书面请求及相关证据，我们会在验证企业身份后处理企业的请求。</p>
                        <p style={{height: '.56rem'}}></p>
                        <p style={{textAlign: 'right'}}>北京百度网讯科技有限公司</p>
                        <p style={{textAlign: 'right'}}>2020年2月14日生效</p>
                    </div>
                </div>
            ),
            disabledHtml: true,
            okText: '同意并继续申请',
            okClick: () => {
                this.confirm && this.confirm();
            }
        });
    }

    userPhoneChange = val => {
        let fruit = false;
        let hint = '';
        if (this.isEmpty(val)) {
            hint = '电话号码不能为空';
            fruit = this.isEmpty(val);
        } else if (!this.isPhone(val)) {
            hint = '电话号码格式不正确，请确认';
            fruit = !this.isPhone(val);
        }
        this.setState({
            userPhoneError: fruit,
            userPhoneVal: val,
            userPhoneErrorHint: hint
        });
        return !fruit;
    };

    userEmailChange = val => {
        let fruit = false;
        let hint = '';
        if (this.isEmpty(val)) {
            hint = '邮箱不能为空';
            fruit = this.isEmpty(val);
        } else if (!this.isEmail(val)) {
            hint = '邮箱格式不正确，请确认';
            fruit = !this.isEmail(val);
        }
        this.setState({
            userEmailError: fruit,
            userEmailVal: val,
            userEmailErrorHint: hint
        });
        return !fruit;
    };

    submitFun = () => {
        let {
            overallTypeIndex,
            enterpriseName,
            userName,
            userPhoneVal,
            userEmailVal,
            overallTextarea,
            codeVal,
            from
        } = this.state;
        this.setState({
            enterpriseNameError: this.isEmpty(enterpriseName),
            userNameError: this.isEmpty(userName),
            codeError: this.isEmpty(codeVal),
            codeHint: this.isEmpty(codeVal) ? '验证码不能为空' : ''
        });
        this.userPhoneChange(userPhoneVal);
        this.userEmailChange(userEmailVal);
        if (!this.isEmpty(userName)
            && this.userPhoneChange(userPhoneVal)
            && this.userEmailChange(userEmailVal)
            && !this.isEmpty(codeVal)) {

            if (overallTypeIndex === 2) {
                if (this.isEmpty(enterpriseName)) {
                    return;
                }
            }

            let json = {
                'company_name': enterpriseName,
                'real_name': userName,
                'phone_number': userPhoneVal.replace(/\s+/g, ''),
                'email': userEmailVal.replace(/\s+/g, ''),
                'id_type': overallTypeIndex,
                'note': overallTextarea + ' - 慧推',
                'catpcha': codeVal,
                'from': from
            };

            if (overallTypeIndex === 1) {
                delete json['company_name'];
            }

            this.props.fetchUserApply(json).then(() => {
                const cmsapiUserapply = this.props.cmsapiUserapply;
                if (location.href.indexOf('testError') !== -1) {
                    alert(cmsapiUserapply.msg);
                }
                if (cmsapiUserapply.is_error === 0) {
                    window.location.href = 'https://console.bce.baidu.com/spp/?cf=aqgw';
                }

                if (cmsapiUserapply.is_error === 3) {
                    this.setState({
                        codeError: true,
                        codeHint: '验证码不正确',
                        codeImg: `/catpcha?t=${Date.now()}`
                    });
                }
            });
        }
    };

    isEmpty = val => {
        let reg = /\S/;
        return !reg.test(val);
    };

    isEmail = val => {
        let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        let value = val.replace(/\s/g, '');
        return reg.test(value);
    };

    render() {
        let {
            overallTypeIndex,
            enterpriseNameError,
            overallTextarea,
            userNameError,
            codeError,
            userPhoneError,
            userEmailError,
            userPhoneErrorHint,
            userEmailErrorHint,
            codeHint,
            codeImg
        } = this.state;

        let enterpriseClass = classnames({
            'input-disable': overallTypeIndex === 1,
            'on': enterpriseNameError && overallTypeIndex !== 1
        });

        return (
            <div className={'apply'}>
                <h2>
                    业务咨询
                </h2>
                <div className={'spu-apply-from'}>
                    <form>
                        <List>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 身份类型：
                            </div>
                            <div className={'apply-form-assist'}>
                                {this.overallType.map((item, index) => {
                                    return <div
                                        className={'overall-type-box'}
                                        key={index}
                                        onClick={() => {
                                            this.setState({
                                                overallTypeIndex: item.id
                                            });
                                        }}
                                    >
                                        <span className={overallTypeIndex === item.id ? 'on' : ''}></span>
                                        <span>{item.val}</span>
                                    </div>;
                                })
                                }
                            </div>
                        </List>

                        <List className={enterpriseClass}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 企业名称：
                            </div>
                            <InputItem
                                placeholder="请输入真实企业名称"
                                disabled={overallTypeIndex === 1}
                                onBlur={val => {
                                    this.setState({
                                        enterpriseName: val
                                    });
                                }}

                            />
                            <div className={'apply-error-hint'}>企业名称不能为空</div>
                        </List>

                        <List className={userNameError ? 'on' : ''}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 真实姓名：
                            </div>
                            <InputItem
                                placeholder="请输入真实姓名便于联系"
                                onBlur={val => {
                                    this.setState({
                                        userName: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}>真实姓名不能为空</div>
                        </List>

                        <List className={userPhoneError ? 'on' : ''}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 电话号码：
                            </div>
                            <InputItem
                                type={'phone'}
                                placeholder="请输入真实电话号码便于联系"
                                onChange={val => {
                                    this.setState({
                                        userPhoneVal: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}>
                                {userPhoneErrorHint}
                            </div>
                        </List>

                        <List className={userEmailError ? 'on' : ''}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 邮箱：
                            </div>
                            <InputItem
                                type={'email'}
                                placeholder="请输入真实邮箱便于联系"
                                onChange={val => {
                                    this.setState({
                                        userEmailVal: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}>
                                {userEmailErrorHint}
                            </div>
                        </List>

                        <List>
                            <div className={'apply-form-title'}>
                                APP名称：
                            </div>
                            <InputItem
                                placeholder={'请描述您想咨询的APP名称'}
                                value={overallTextarea}
                                onChange={val => {
                                    this.setState({
                                        overallTextarea: val
                                    });
                                }}
                            />
                            <div className={'apply-error-hint'}></div>
                        </List>

                        <List className={codeError ? 'codeInput on' : 'codeInput'}>
                            <div className={'apply-form-title'}>
                                <span className={'hint-star'}>*</span> 验证码：
                            </div>
                            <InputItem
                                placeholder="请输出右侧验证码"
                                onChange={val => {
                                    this.setState({
                                        codeVal: val,
                                        codeError: !val.replace(/\s+/g, '')
                                    });
                                }}
                            />
                            <div
                                className="overall-code"
                                onClick={() => {
                                    this.setState({
                                        codeImg: ''
                                    }, () => {
                                        this.setState({
                                            codeImg: '/catpcha'
                                        });
                                    });
                                }}
                            >
                                <img src={codeImg} alt="" height="100%" />
                            </div>
                            <div className={'apply-error-hint'}>
                                {codeHint}
                            </div>
                        </List>

                    </form>
                </div>
                <div className={'apply-subbtn'} onClick={this.submitFun}>
                    提交并体验
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        userLoginstate: state.userLoginstate,
        userApplyData: state.userApplyData,
        cmsapiUserapply: state.cmsapiUserapply
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchCmsapiIndexData: () => fetchCmsapiIndexData(dispatch),
        fetchUserApply: obj => fetchUserApply(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Apply);



// WEBPACK FOOTER //
// ./src/containers/apply_app/index.js